import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import {
  withFixedColumnsScrollEvent,
  withFixedColumnsStickyPosition,
} from "react-table-hoc-fixed-columns";
import { message, Input } from "antd";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { Card, CardBody, Row, Col } from "reactstrap";
import PageTitle from "../../../../../Layout/AppMain/PageTitle";
import UpdateUserModal from "./updateUser";
import CreateUserModal from "./createUser";
import {
  onDeleteUserWeb,
  onFetchListUserWeb,
  onFetchListUserWebSearch,
} from "../../../../../Api/AppBackend/User";
import InlineAction from "../../../../../Components/CustomTable/InlineAction";
import Pagination from "../../../../../Components/CustomTable/Pagination";
import Loader from "react-loaders";
import { useHistory } from "react-router-dom";
import "./input.css";
import { withTranslation } from "react-i18next";

const ReactTableFixedColumns = withFixedColumnsStickyPosition(ReactTable);

const UserManagement = (props) => {
  const [listUser, setListUser] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [curObj, setCurObj] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSizeOptions, setPageSizeOptions] = useState([
    50, 100, 200, 300, 500, 1000,
  ]);
  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();
  const pages = Math.floor(totalRecords / pageSize);//Tính số trang
  const startIndex = pageIndex * pageSize;//Tính số thứ tự bắt đầu
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([]);
  
  const convertTypeUser = (typeUser) => {
    switch (typeUser) {
      case 1:
        return props.t("Admin");
      case 2:
        return props.t("Object");
      case 3:
        return props.t("Test Request Location");
      case 4:
        return props.t("Patient");
      default:
        return "";
    }
  };

  const convertSex = (sex) => {
    switch (sex) {
      case "F":
        return props.t("Female");
      case "M":
        return props.t("Male");
      default:
        return "";
    }
  };

  const onGetListUser = async () => {
    setLoading(true);
    const res = await onFetchListUserWeb(pageSize, pageIndex);
    if (res.data.isSuccess) {
      setLoading(false);
      const formattedData = res.data.data.map((record, index) => ({
        index: startIndex + index + 1,
        userID: record.userID,
        userName: record.userName,
        address: record.address,
        typeUser: convertTypeUser(record.typeUser),
        sex: convertSex(record.sex),
        phone: record.phone,
        objectID: record.objectID,
        locationID: record.locationID
      }));
      setListUser(formattedData);
      setTotalRecords(res.data.totalRecords);
      const filteredata = filterDataManual(formattedData, filters)
      setData(filteredata)
    }
  };

  const onSearchUserList = async (searchTerm) => {
    setLoading(true);
    const res = await onFetchListUserWebSearch(searchTerm);
    if (res.data.isSuccess) {
      setLoading(false);
      const formattedData = res.data.data.map((record, index) => ({
        index: startIndex + index + 1,
        userID: record.userID,
        userName: record.userName,
        address: record.address,
        typeUser: convertTypeUser(record.typeUser),
        sex: convertSex(record.sex),
        phone: record.phone,
        objectID: record.objectID,
        locationID: record.locationID
      }));
      setListUser(formattedData);
      setTotalRecords(res.data.totalRecords);
      const filteredata = filterDataManual(formattedData, filters)
      setData(filteredata)
    } else {
      message.error(res.data.err.msgString);
    }
  };

  const onHandleDelteUser = async (userID) => {
    setLoading(true);
    try {
      const res = await onDeleteUserWeb(userID);
      if (res.data.isSuccess) {
        setLoading(false);
        message.success(props.t("User deleted successfully!"));
        onGetListUser();
      } else {
        message.error(props.t("Failed to delete user!"));
      }
    } catch (err) {
      message.error(
        err.message || props.t("An error occurred while deleting the user")
      );
    }
  };

  const onHandleSearchChange = () => {
    const searchTerm = searchInputRef.current?.input?.value || "";
    if (searchTerm.trim() !== "") {
      onSearchUserList(searchTerm);
    } else {
      onGetListUser();
    }
  };

  const onHandlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  const onHandlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  const onKeyPressEnter =(e) =>{
    if(e.key === 'Enter')
    {
      onHandleFilterChange(e.target.value)
    }
  }

  const onHandleFilterChange = (newFilters) => {
    setFilters(newFilters);
    const filterResult = filterDataManual(listUser, newFilters);
    setData(filterResult);
  };

  const filterDataManual = (data, filters) => {
    if (!filters || filters.length === 0) return data;
    return data.filter((row) => {
      return filters.every((filter) => {
        const { id, value } = filter;
        if (!value) return true;
        const cellValue = row[id] ? String(row[id]).toUpperCase() : "";
        return cellValue.includes(String(value).toUpperCase());
      });
    });
  };

  const defaultFilterMethod = (filter, row) => {
    const value = row[filter.id];
    const filterValue = filter.value;

    if (!value) return false;

    if (typeof filterValue === "object") {
      return filterValue.includes(value);
    }
    return String(value)
      .toLowerCase()
      .includes(String(filterValue).toLowerCase());
  };

  const onDeleteUserClick = (userID) =>
  {
    onHandleDelteUser(userID)
  }

  const onEditUserClick = (user) =>
  {
    setEditModal(true);
    setCurObj(user);
  }

  const onHandleRefresh = async () => {
    setPageIndex(0);
    // pageSizeOptions(100);
    // await onGetListUser(0);
  };

  useEffect(() => {
    const typeUser = Number(localStorage.getItem("typeUser"));
    if (typeUser !== 1) {
      message.error(props.t("You do not have permission to access this page"));
      history.push("/");
    }
  }, [history]);

  useEffect(() => {
    onGetListUser();
  }, [pageSize, pageIndex]);

  const getTrProps = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e) => {
          if (e.detail === 2) {
            setEditModal(true);
            setCurObj(rowInfo.row);
          }
        },
      };
    } else {
      return {};
    }
  };

  const Columns = useMemo(
    () => [
      {
        Header: `${props.t("Action")}`,
        id: "index",
        sortable: false,
        filterable: false,
        width: 100,
        fixed: "left",
        Cell: ({ row }) => (
          <InlineAction
            id={`deletecategorybtn-${row.index}`}
            onDeleteClick={() => onDeleteUserClick(row._original.userID)}
            onEditClick={() => onEditUserClick(row._original)}
          />
        ),
      },
      {
        filterable: false,
        resizable: false,
        sortable: false,
        accessor: "index",
        width: 50,
        Header: `${props.t("No.")}`,
        Cell: ({ value }) => <div>{value}</div>,
      },
      {
        Header: `${props.t("Username")}`,
        filterable: true,
        accessor: "userID",
        width: 300,
      },
      {
        Header: `${props.t("Full name")}`,
        filterable: true,
        accessor: "userName",
        width: 300,
      },
      {
        Header: `${props.t("Address")}`,
        filterable: true,
        accessor: "address",
      },
      {
        Header: `${props.t("Account type")}`,
        filterable: true,
        accessor: "typeUser",
        width: 150,
      },
      {
        Header: `${props.t("Gender")}`,
        filterable: true,
        accessor: "sex",
        width: 150,
      },
      {
        Header: `${props.t("Phone number")}`,
        filterable: true,
        accessor: "phone",
        width: 150,
      },
      {
        Header: `${props.t("Object Code")}`,
        filterable: false,
        accessor: "objectID",
        width: 150,
        show: false
      },
      {
        Header: `${props.t("Location Code")}`,
        filterable: false,
        accessor: "locationID",
        width: 150,
        show: false
      },
    ],
    [props]
  );

  return (
    <div className="user-container">
      <div className="tittle-name-container">
        <div className="tittle-name-user">{props.t("USER MANAGEMENT")}</div>
        <div className="tittle-input-footer">
          <div className="tittle-input-action">
            <Input
              ref={searchInputRef}
              style={{
                fontSize: "15px",
                fontWeight: 400,
                color: "#fff !important",
                background: "#fff",
                zIndex: 100,
                width: "300px",
              }}
              placeholder={props.t("Search by PID, FullName, PhoneNumber")}
              onPressEnter={onHandleSearchChange}
            />
          </div>
          <div className="tittle-input-search">
            <PageTitle
              useAddNew={true}
              onClickAddNew={() => {
                setCreateModal(true);
              }}
              useRefresh={true}
              setLoading={setLoading}
              onClickRefresh={onHandleRefresh}
            />
          </div>
        </div>
      </div>
      <div className="table-user-management">
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col md="12" style={{ padding: 0 }}>
              <Card>
                <CardBody style={{ paddingBottom: "10px" }}>
                  <ReactTableFixedColumns
                    data={data}
                    filterable
                    loading={loading}
                    loadingText={<Loader type="ball-pulse-rise" />}
                    defaultFilterMethod={defaultFilterMethod}
                    columns={Columns}
                    showPaginationBottom={true}
                    rowsText={props.t("rows")}
                    ofText={"/"}
                    pageText={props.t("Page")}
                    previousText={props.t("Previous page")}
                    nextText={props.t("Next page")}
                    noDataText={props.t("No data")}
                    pageSizeOptions={pageSizeOptions}
                    defaultPageSize={pageSize}
                    pages={pages}
                    pageSize={pageSize}
                    page={pageIndex}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onHandlePageSizeChange}
                    className="-striped -highlight -fixed"
                    getTrProps={getTrProps}
                    manual
                    style={{ height: "calc(100vh - 150px)" }}
                    PaginationComponent={Pagination}
                    onFilteredChange={onHandleFilterChange}
                    onKeyPress={onKeyPressEnter}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <CreateUserModal
            createModal={createModal}
            modal
            setCreateModal={setCreateModal}
            loading={loading}
            setLoading={setLoading}
            globalState={props.global}
            onGetListUser={onGetListUser}
            t={props.t}
          />
          <UpdateUserModal
            editModal={editModal}
            modal
            setEditModal={setEditModal}
            loading={loading}
            setLoading={setLoading}
            globalState={props.global}
            curObj={curObj}
            setCurObj={setCurObj}
            onGetListUser={onGetListUser}
            t={props.t}
          />
        </CSSTransitionGroup>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
  withTranslation(["dashboard"])(UserManagement)
);
